export default __webpack_public_path__ + "static/media/notewrote3.973d332c.jpg";